import store from './../store'

export default {
  path: '/file',
  name: 'file',
  redirect: { name: 'file.list-page' },
  component: () =>
    import(/* webpackChunkName: "file" */ '@/views/file/index.vue'),
  children: [
    {
      path: '/file',
      name: 'file.list-page',
      component: () =>
        import(/* webpackChunkName: "file" */ '@/views/file/FilesPage.vue'),
    },
    {
      path: '/files',
      redirect: { name: 'file.list-page' },
    },
    {
      path: '/file/create',
      name: 'file.new-page',
      component: () =>
        import(
          /* webpackChunkName: "new-file-page" */ '@/views/file/NewFilePage.vue'
        ),
    },
    {
      path: '/file/:id/success',
      name: 'file.success-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/SuccessPage.vue'
        ),
    },
    {
      path: '/file/:id',
      name: 'file.view-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/ViewFilePage.vue'
        ),
    },
    {
      path: '/file/:id/edit',
      name: 'file.edit-page',
      component: () =>
        import(
          /* webpackChunkName: "success-page" */ '@/views/file/EditFilePage.vue'
        ),
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      if (
        store.state.auth.user.user_type !== 'tradie' &&
        store.state.auth.user.user_type !== 'business_admin'
      )
        return next({ name: 'page-not-found' })

      return next()
    }

    // next() must be called exactly once per pass (see routes/openToWork.js
    // for the same pattern) — this used to also call a bare next() in
    // .finally() regardless of the .then()/.catch() outcome, which raced
    // against the redirect and could resolve to page-not-found instead of
    // the file or the login page.
    store
      .dispatch('auth/getAuthenticatedUser')
      .then(() => {
        if (
          store.state.auth.user.user_type !== 'tradie' &&
          store.state.auth.user.user_type !== 'business_admin'
        )
          next({ name: 'page-not-found' })
        else next()
      })
      .catch(() => next({ name: 'auth.login-page' }))
  },
}
